import { ApiRequest } from "src/helpers";
import { API_END_POINTS } from "src/constants";

export function convertToSaleLeadApi(id) {
    return ApiRequest.fetchAdmin({
      method: "post",
      url: `${API_END_POINTS.UPDATE_LEAD}/${id}/convert_to_sale`,
    }).then((response) => response.data.lead);
  }